"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processSubmission = exports.filterSearch = exports.default = void 0;
const processSubmission = (e, input, handleSubmit, name) => {
  e.preventDefault();
  if (!input || input.length < 1) {
    return null;
  }
  handleSubmit(input, name);
};
exports.processSubmission = processSubmission;
const filterSearch = function () {
  let searchItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let input = arguments.length > 1 ? arguments[1] : undefined;
  return searchItems.filter(item => {
    return item.toLowerCase().includes(input.toLowerCase()) && item !== input;
  });
};
exports.filterSearch = filterSearch;
const renderPredictiveSearchItems = function () {
  let searchItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let input = arguments.length > 1 ? arguments[1] : undefined;
  let setInput = arguments.length > 2 ? arguments[2] : undefined;
  if (searchItems.includes(input)) {
    return [];
  }
  const filteredSearch = filterSearch(searchItems, input);
  return filteredSearch.map((item, index) => {
    return /*#__PURE__*/React.createElement("li", {
      className: "ter-search-bar__predicted-list-item",
      key: `${item}-${index}`,
      onClick: () => setInput(item)
    }, item);
  });
};
var _default = renderPredictiveSearchItems;
exports.default = _default;